import React from 'react';
import l10n from "../../../l10n/localization";
import * as utilsCommon from "../../../utils/utils";
import AdditionalCharges from "./AdditionalCharges";
import {Button} from "react-materialize";
import AdditionalChargeForm from "../../forms/AdditionalChargeForm";
import * as creationActions from "../../../actions/creation";
import * as documentActions from "../../../actions/documents";
import ListDocuments from "./ListDocuments";
import * as utilsFog from "../../../utils/fog";
import * as fogActions from "../../../actions/fog";

export default class Client extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getFog();
    }

    getFog() {
        return utilsFog.fogToForm(this.props.fogs.getById(this.props.fog.id).original);
    }

    generateDocument(type) {
        console.log('/// test --  genarate///',this.props.fog);
        this.props.dispatch(documentActions.generateDocuments(this.props.fog.id, type, this.props.displayAll));
    }

    countTypedAdditionnalCharge(invoices, type) {
        let counter = 0;

        for (let i = 0; i < invoices.length; i++) {
            if (invoices[i].document_type === type) {
                counter++;
            }
        }
        return counter
    }

    onVat8ClientCheckboxClick() {
        let newValue = !this.state.vat8Client;
        let form = Object.assign({}, {...utilsFog.fogToForm(this.props.fogs.getById(this.props.fog.id).original), comments: this.state.comments});
        form.vat8Client = newValue;

        this.setState({...this.state, vat8Client: newValue}, this.props.dispatch(fogActions.edit(form, false, this.props.displayAll)));
    }

    render() {
        let tmp = this.props.fogs.getById(this.props.fog.id);
        let totalCreditNote = this.props.total.client.fogSettlement + this.props.total.additionalChargesSumTyped['CREDIT_NOTE_CLIENT'];

        return (
            <section>
                <h2 className="yellow-border">{l10n.fog.client}</h2>
                <div className="content">
                    <article>
                        <table>
                            <tbody>
                            <tr className="row">
                                <td className="col s5">
                                    <span className="title">{l10n.fog.invoice}</span>
                                </td>
                                <td className="col s3 right-align">
                                    <span
                                        className="total">{l10n.fog.total} {utilsCommon.money(this.props.total.client.total.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s4 right-align">
                                    <button className="btn btn-primary full" disabled={this.props.generating} onClick={() => this.generateDocument('INVOICE_CLIENT')}>{l10n.common.btnGenerateInvoice}</button>
                                    <br />
                                    <ListDocuments dispatch={this.props.dispatch} fog={this.props.fog} fogReference={tmp.original.reference} documents={tmp.sortedDocuments['INVOICE_CLIENT'] !== undefined ? tmp.sortedDocuments['INVOICE_CLIENT'] : []} />
                                </td>
                            </tr>
                            <tr className="row">
                                <td className="col s5">
                                    <span>{l10n.fog.premiumCharges}</span>
                                </td>
                                <td className="col s3 right-align">
                                    <span>{utilsCommon.money(this.props.total.client.fogPremium.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s4"/>
                            </tr>
                            {tmp.original.overage && tmp.original.overageClientRate > 0 &&
                            <tr className="row">
                                <td className="col s5">
                                    <span>{l10n.fog.overageLabel}</span>
                                </td>
                                <td className="col s3 right-align">
                                    <span>{utilsCommon.money(this.props.total.client.overage.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s4"/>
                            </tr>
                            }
                            <tr className="row">
                                <td className="col s7">
                                    <span>{l10n.fog.additionalCharges}</span>
                                </td>
                                <td className="col s7">
                                    <AdditionalCharges {...this.props} type='INVOICE_CLIENT' />
                                    <i className="left-align">
                                        <Button
                                            style={{marginTop: tmp.original.invoices !== undefined && this.countTypedAdditionnalCharge(tmp.original.invoices, 'INVOICE_CLIENT') > 0 ? "-94px" : ""}}
                                            type="button" floating
                                            onClick={() => this.props.openDrawer(AdditionalChargeForm, {
                                                item: null,
                                                fog: this.props.fog,
                                                type: 'INVOICE_CLIENT'
                                            }, creationActions.destroyingnewlyCreatedInvoice())} icon="add" className="add-button small"/>
                                    </i>
                                    <span
                                        style={{float: "right"}}>{utilsCommon.money(this.props.total.additionalChargesSumTyped['INVOICE_CLIENT'].toFixed(3), this.props.currency)}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </article>
                    <article>
                        <table>
                            <tbody>
                            <tr className="row">
                                <td className="col s5">
                                    <br/>
                                    <span className="title">{l10n.fog.creditNote}</span>
                                </td>
                                <td className="col s3 right-align">
                                    <br/>
                                    <span
                                        className="total">{l10n.fog.total} {utilsCommon.money(totalCreditNote.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s4 right-align"/>
                            </tr>
                            <tr className="row">
                                <td className="col s5">
                                    <span>{l10n.fog.fogSettlement}</span>
                                </td>
                                <td className="col s3 right-align">
                                    <span>{utilsCommon.money(this.props.total.client.fogSettlement.toFixed(3), this.props.currency)}</span>
                                </td>
                                <td className="col s4 right-align">
                                    <button
                                        className="btn btn-primary full" disabled={this.props.generating} onClick={() => this.generateDocument('CREDIT_NOTE_CLIENT')}>{l10n.common.btnGenerateCreditNote}</button>
                                    <br />
                                    <ListDocuments dispatch={this.props.dispatch} fog={this.props.fog} fogReference={tmp.original.reference} documents={tmp.sortedDocuments['CREDIT_NOTE_CLIENT'] !== undefined ? tmp.sortedDocuments['CREDIT_NOTE_CLIENT'] : []}  />
                                </td>
                            </tr>
                            <tr className="row">
                                <td className="col s7">
                                    <span>{l10n.fog.additionalCharges}</span>
                                </td>
                                <td className="col s7">
                                    <AdditionalCharges {...this.props} type='CREDIT_NOTE_CLIENT' />
                                    <i className="left-align">
                                        <Button
                                            style={{marginTop: tmp.original.invoices !== undefined && this.countTypedAdditionnalCharge(tmp.original.invoices, 'CREDIT_NOTE_CLIENT') > 0 ? "-94px" : ""}}
                                            type="button" floating
                                            onClick={() => this.props.openDrawer(AdditionalChargeForm, {
                                                item: null,
                                                fog: this.props.fog,
                                                type: 'CREDIT_NOTE_CLIENT'
                                            }, creationActions.destroyingnewlyCreatedInvoice())} icon="add" className="add-button small"/>
                                    </i>
                                    <span
                                        style={{float: "right"}}>{utilsCommon.money(this.props.total.additionalChargesSumTyped['CREDIT_NOTE_CLIENT'].toFixed(3), this.props.currency)}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </article>

                    <br />
                    <div className="col s6">
                        <div className="form-group field field-string">
                            <input type="checkbox"
                                   name={'root_vat8Client'}
                                   value={'root_vat8Client'}
                                   checked={this.state.vat8Client}
                                   onChange={() => {}}
                                   disabled={this.props.loading}
                            />
                            <label htmlFor={'root_vat8Client'}
                                   onClick={this.onVat8ClientCheckboxClick.bind(this)}>Client VAT 7.7%</label>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


/**

 <Row>
 <Col s={7} className="no-padding">
 <h3>Invoice</h3>
 </Col>
 <Col s={2} className="no-padding">
 <div>Total ...</div>
 <div>{utilsCommon.money(utilsFog.calculateFogTotal(this.props.fog), this.props.currency)}</div>
 </Col>
 <Col s={3} className="no-padding">
 <a href="#" className="btn btn-primary">{l10n.common.btnGenerateInvoice}</a>
 </Col>
 </Row>
 </article>
 <article>
 <Row>
 <Col s={7} className="no-padding">
 <h3>Credit Note</h3>
 </Col>
 <Col s={2} className="no-padding">
 Total & all
 </Col>
 <Col s={3} className="no-padding">
 <a href="#" className="btn btn-primary">{l10n.common.btnGenerateCreditNote}</a>
 </Col>
 </Row>

 */


// WEBPACK FOOTER //
// ./src/components/fog/costInvoice/Client.js